module.exports = __webpack_public_path__ + "img/mtp-primary-photo.51c2704d.jpeg";